module.exports = __webpack_public_path__ + "static/media/Screenshot_4.4b65e5a9.png";